export const giftCard = "Gift card";

export const giftVoucher = "Standard";

export const returnsVoucher = "Out of policy return";
